import React, { lazy, Suspense, useMemo } from "react";
import { observer } from "mobx-react-lite";
import _ from "lodash";
import { useStore } from "../../../helpers";
import { FieldSummaryForRohan } from "./field-summary-for-rohan";
import { SurveysByDate } from "./surveys-by-date";
import { SurveysLevel1 } from "./surveys-by-level1";
import { SurveysByAudio } from "./surveys-by-audio";
import { SurveysByDateHour } from "./surveys-by-date-hour";
import { SurveysByLevel1Audio } from "./surveys-by-level1-audio";
import { SurveysByLevel2Audio } from "./surveys-by-level2-audio";
import { SurveysByQaCheck } from "./surveys-by-qa-check";
import { SurveysByUserHL } from "./surveys-by-user-hl";
import { SurveysBylevel1HL } from "./survey-by-level1-hl";
import { SurveysBylevel2HL } from "./surveys-by-level2-hl";
import { SurveysByDateHL } from "./surveys-by-date-hl";
import { SurveysByAudioOnly } from "./survey-by-audio-only";
import { SurveysByQaCheckOly } from "./survey-by-qa-check-only";
import { Typography } from "@mui/material";
import Masonry from "@mui/lab/Masonry";
import { LoadingState } from "../../../components";
import { UserSummaryTable } from "./users-summary";
import FieldKpiCards from "./Field-cards";
import { toJS } from "mobx";
const SurveysByUser = lazy(() => import("./surveys-by-user"));
const SurveysLevel2 = lazy(() => import("./surveys-by-level2"));

export const TableHeader = ({ title }) => {
    return (
        <Typography color={"primary"} variant={"h6"} sx={{ fontWeight: "bold", margin: "15px 0px 10px 0px" }}>
            {title}
        </Typography>
    );
};

type SurveySummaryProps = {
    summary?: any;
};

// export const SurveySummary = observer((props) => {
//     const { surveyResponseStore } = useStore();
//
//     const { allSurveyResponsesSummary } = surveyResponseStore;

export const SurveySummary = observer(({ summary }: SurveySummaryProps) => {
    const { surveyResponseStore } = useStore();

    const allSurveyResponsesSummary = summary ?? surveyResponseStore.allSurveyResponsesSummary;
    console.log("Summary Object", toJS(allSurveyResponsesSummary));

    console.log("Summary Keys", Object.keys(toJS(allSurveyResponsesSummary || {})));
    const data = useMemo(
        () => allSurveyResponsesSummary?.["by_piv_level2_surveyor_id_qa_status"] || [],
        [allSurveyResponsesSummary]
    );

    if (_.isEmpty(allSurveyResponsesSummary)) return null;

    return (
        <Suspense fallback={<LoadingState />}>
            <div className="gap-y-2">{/*<FieldKpiCards />*/}</div>
            <Masonry columns={{ sm: 1, md: 2, lg: 3, xl: 3 }} spacing={2}>
                <SurveysByUser />
                <SurveysByDate />
                <SurveysByDateHour />
                <SurveysLevel1 />
                <SurveysLevel2 />
                <SurveysByAudio />
                <SurveysByLevel1Audio />
                <SurveysByLevel2Audio />
                <SurveysByUserHL />
                <SurveysByQaCheck />
                <SurveysByQaCheckOly />
                <SurveysByAudioOnly />
                <SurveysBylevel1HL />
                <SurveysBylevel2HL />
                <SurveysByDateHL />
                <FieldSummaryForRohan />
            </Masonry>
            <div className="max-w-4xl">
                <UserSummaryTable data={data} />
            </div>
        </Suspense>
    );
});
